import Swiper, {  Autoplay } from 'swiper'

const swiperCompanies = new Swiper('.slider-companies', {
  modules: [
    Autoplay
  ],
  loop: true,
  slidesPerView: 6,
  spaceBetween: 20,
  allowTouchMove: false,
  autoplay: {
    delay: 1000,
    disableOnInteraction: false
  },
  breakpoints: {
    1024: {
      slidesPerView: 8,
    },
  },
})
